import { Component, computed, inject, input, resource } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { BrugerHistorikApi } from '@features/brugere/bruger-historik/bruger-historik.api';

@Component({
  selector: 'app-bruger-historik',
  imports: [DatePipe, TableModule, TableRowDirective],
  templateUrl: './bruger-historik.component.html',
  styleUrl: './bruger-historik.component.css',
})
export class BrugerHistorikComponent {
  brugerId = input.required<number>();
  brugerHistorikApi = inject(BrugerHistorikApi);

  historik = computed(() => {
    const apiResponse = this.data.value();
    return apiResponse?.data || [];
  });

  data = resource({
    params: () => this.brugerId(),
    loader: async ({ params, abortSignal }) => {
      return await this.brugerHistorikApi.getList(
        {
          filter: JSON.stringify({
            brugerId: params,
          }),
          sortBy: 'tidspunkt',
          descending: true,
        },
        abortSignal
      );
    },
  });
}
